var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"progress-bar--filled",style:({ width: _vm.value + '%' })})])}
var staticRenderFns = []

export { render, staticRenderFns }